import { stringify } from "query-string";
import axios from "utils/axios";

export const getLocationTrackings = (params) => {
  const query = stringify(params);
  return axios.get(`/hr/locationTrackings/map?${query}`);
};
